import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CONTACT_NOTE_EDIT_FORM_SCHEMA = yup.object().shape({
  content: yup.string().required('Molimo Vas da unesete bilješku'),
});

